import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, FilterProvider, ScrollProvider, SpellListFilterProvider, ToastProvider } from './context';
import { ActiveListProvider } from './context/ActiveListContext';
import { SettingsProvider } from './context/SettingsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <SettingsProvider>
            <ActiveListProvider>
              <FilterProvider>
                <SpellListFilterProvider>
                  <ScrollProvider>
                    <App />
                  </ScrollProvider>
                </SpellListFilterProvider>
              </FilterProvider>
            </ActiveListProvider>
          </SettingsProvider>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
